const MONTHS = ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Aoû', 'Sep', 'Oct', 'Nov', 'Déc'];

export default function CalendarNavigation({ currentDate, onChange }) {
  const changeYear = (offset) => {
    const next = new Date(currentDate);
    next.setFullYear(next.getFullYear() + offset);
    onChange(next);
  };

  const changeMonth = (monthIndex) => {
    const next = new Date(currentDate);
    next.setMonth(monthIndex);
    onChange(next);
  };

  return (
    <div className="calendar-months">
      <div className="year-nav">
        <button type="button" onClick={() => changeYear(-1)}>◀</button>
        <span className="year-label">{currentDate.getFullYear()}</span>
        <button type="button" onClick={() => changeYear(1)}>▶</button>
      </div>

      <div className="months-row">
        {MONTHS.map((month, index) => (
          <button
            key={month}
            type="button"
            className={`month-btn ${currentDate.getMonth() === index ? 'active' : ''}`}
            onClick={() => changeMonth(index)}
          >
            {month}
          </button>
        ))}
      </div>
    </div>
  );
}
